import { Image as AntImage } from 'antd'

export const Image = (props) => {
  return <AntImage {...props} />
}
